import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFridge"><Path d="M4.5 2.5H19.5V21.5H4.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 6.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 13.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 10.5H4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFridge;
